module.exports = __webpack_public_path__ + "static/img/2.0e865a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/sp/2.png
// module id = zPSI
// module chunks = 0